import { Box, H3 } from '../../widgets'
import { useBackground } from '../../layout'
import { assetUrl } from '../../../utilities.js'
import './Waiting.scss'

export const Waiting = ({ active }) => {
  useBackground().set({ active, background: null })

  return (
    <Box justifyContent="center" alignItems="center" fullHeight fullWidth column container>
      <video src={assetUrl('videos/holding-screen.mp4')} className="waiting-video" autoPlay muted playsInline loop />
      <Box className="waiting-text">
        <H3 className="blink" align="center" opacity={0} color="white">
          Waiting for host...
        </H3>
      </Box>
    </Box>
  )
}